module.exports = __webpack_public_path__ + "static/media/acms-division.75b35e91.svg";